<template>
  <v-list-item
    class="sidebar-nav-option mb-1"
    :style="{ color: palette.gwDarkPurple }"
    link
    v-bind="{ id: `layout-menu-item-${suffix}` }"
  >
    <div class="d-flex align-center py-1">
      <div class="v-list-item-icon">
        <navigation-icon :icon="icon" />
      </div>
      <div class="ml-2 v-list-item-content">
        <v-list-item-title>{{ title }}</v-list-item-title>
      </div>
    </div>
  </v-list-item>
</template>

<script setup lang="ts">
import { computed } from "vue";
import palette from "@/guac-layout/styles/variables.module.scss";
import NavigationIcon from "./NavigationIcon.vue";

interface Props {
  title: string;
  idSuffix: string;
  icon: string;
}
const props = defineProps<Props>();

const suffix = computed(() => {
  return props.idSuffix?.toLowerCase().replace(/ /g, "-");
});
</script>
<style lang="scss">
.guac-layout-header {
  position: relative;
  z-index: 99999 !important;

  #sidebar {
    border: none !important;
  }
  .bar {
    width: 100%;
    height: 32px;
    background-color: $gw-dark-purple;
  }
  .v-list-item-icon {
    .v-btn {
      pointer-events: none;
    }
  }
  .v-list-item-content {
    user-select: none;
  }
  .getwell-name {
    color: $gw-dark-purple;
    font-weight: 500;
    font-family: $font-serif !important;
  }
  .v-list {
    min-height: calc(100% - 120px);
    // color: $gw-dark-purple !important;
  }
  .v-list-item-title {
    font-size: 1em !important;
    font-weight: normal !important;
    font-family: $font-serif !important;
    color: $gray !important;
  }
  .v-app-bar-nav-icon {
    &:hover {
      background-color: rgba(227, 221, 243, 1) !important;
    }
  }
  .v-app-bar .v-btn {
    margin: 0px;
  }
  .v-list-group__items .v-list-item {
    padding-left: 2em !important;
  }
}
</style>
